import { render, staticRenderFns } from "./ReconcileOrderPreview.vue?vue&type=template&id=63b70b3a&scoped=true"
import script from "./ReconcileOrderPreview.vue?vue&type=script&lang=js"
export * from "./ReconcileOrderPreview.vue?vue&type=script&lang=js"
import style0 from "./ReconcileOrderPreview.vue?vue&type=style&index=0&id=63b70b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b70b3a",
  null
  
)

export default component.exports